class WallpaperMeasureCalculator {
  constructor(root) {
    this.root = root;
    this.form = root.querySelector('[data-wallpaper-form]');
    this.result = root.querySelector('[data-wallpaper-result]');
    if (!this.form || !this.result) return;
    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      this.calculate();
    });
    this.form.addEventListener('input', () => this.calculate());
    this.calculate();
  }

  calculate() {
    if (!this.form.checkValidity()) return;
    const values = Object.fromEntries(new FormData(this.form));
    const width = Number(values.roomWidth);
    const depth = Number(values.roomDepth);
    const heightCm = Number(values.roomHeight) * 100;
    const paperWidthCm = Number(values.paperWidth);
    const repeatCm = Number(values.repeat) || 0;
    const widthDrops = Math.ceil((width * 100) / paperWidthCm);
    const depthDrops = Math.ceil((depth * 100) / paperWidthCm);
    const drops = (widthDrops + depthDrops) * 2;
    const cutLengthCm = heightCm + 10;
    const dropLengthCm = repeatCm > 0 ? Math.ceil(cutLengthCm / repeatCm) * repeatCm : cutLengthCm;
    const metres = Math.ceil((drops * dropLengthCm) / 100);

    this.result.querySelector('[data-wallpaper-metres]').textContent = metres;
    this.result.querySelector('[data-wallpaper-width-drops]').textContent = `${widthDrops}列 × 2面`;
    this.result.querySelector('[data-wallpaper-depth-drops]').textContent = `${depthDrops}列 × 2面`;
    this.result.querySelector('[data-wallpaper-drops]').textContent = `${drops}列`;
    this.result.querySelector('[data-wallpaper-drop-length]').textContent = `${Number((dropLengthCm / 100).toFixed(2))}m`;
  }
}

document.querySelectorAll('[data-wallpaper-guide]').forEach((root) => new WallpaperMeasureCalculator(root));
